import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  HostBinding,
  Input,
  OnInit,
  Output,
  Renderer2,
  ViewChild
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseInputComponent } from '../_base/base-Input.component';

@Component({
  selector: '[text-input]',
  templateUrl: './input.component.html',
  styleUrls: ['../../styles/label.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputComponent),
      multi: true
    }
  ]
})
export class InputComponent extends BaseInputComponent implements ControlValueAccessor, OnInit {
  @HostBinding('attr.id') externalId = '';

  @ViewChild('input' /** ng8 , {static: true}*/, { static: true }) input: ElementRef;

  @Input() type = 'text';
  // tslint:disable-next-line:no-input-rename
  @Input('disabled') _DISABLED = false;
  @Input() tooltip = '';
  @Input() decimalFormat = '0.01';
  @Input() inputMode = 'text';

  @Output() blur = new EventEmitter();

  @Input()
  set id(value: string) {
    this._ID = value;
    this.externalId = null;
  }

  get id() {
    return this._ID;
  }

  _ID = '';

  private defaultMessages = {
    required: 'Field is required',
    minlength: 'Field does not catch minimal length',
    maxlength: 'Field is over max length',
    pattern: 'Field does not match the validation pattern',
  };

  _VALUE = '';

  @Input('value')
  set value(val) {
    this._VALUE = val;
  }

  get value() {
    return this._VALUE;
  }

  onChange: any = () => {};
  onTouched: any = () => {};

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2
  ) {
    super();
  }

  ngOnInit(): void {
    this.messages = Object.assign(this.defaultMessages, this.messages);
    this.renderer.addClass(this.elementRef.nativeElement, 'form-group');
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this._DISABLED = isDisabled;
  }

  writeValue(obj: any): void {
    if (obj === null) {
      this.input.nativeElement.value = '';
    }
    this.value = (obj !== null && obj !== undefined) ? obj : '';
  }

  doChange($event) {
    this.onInputChange.emit($event.target.value);
    this.onChange($event.target.value);
    this.onTouched();
  }

  focus() {
    const t = setTimeout(() => {
      this.input.nativeElement.focus();
      clearTimeout(t);
    }, 25);
  }
}
